export default __webpack_public_path__ + "static/media/TimberTradeTrajectory.e87d42b5.png";